import { memo } from 'react'
import { Text } from 'common-components'
import SpinningLoader from 'common-components/SpinningLoader'
import PlayIcon from 'assets/svgr-icons/Play.svg'
import { COLORS } from 'consts/colors'
import { T } from 'consts/translationKeys'
import { translate } from 'utils/translations'
import { TPlayState } from '../types'
import * as Styled from './styled'

interface IProps {
  playState: TPlayState
  progress: number
  disabled: boolean
  onClick: () => void
}

// Progress ring geometry (drawn inside the 24px IconSlot).
const RING_RADIUS = 11
const RING_CIRCUMFERENCE = 2 * Math.PI * RING_RADIUS

const PlayControl: React.FC<IProps> = ({
  playState,
  progress,
  disabled,
  onClick
}) => {
  const isPlaying = playState === 'playing'

  return (
    <Styled.PlayControlWrapper>
      <Styled.IconSlot
        $disabled={disabled}
        onClick={disabled ? undefined : onClick}
      >
        {playState === 'loading' ? (
          <SpinningLoader
            loaderColor={COLORS.primaryDark}
            size={12}
            wrapperSize={14}
            strokeWidth={2.5}
          />
        ) : isPlaying ? (
          <>
            <Styled.ProgressRing viewBox="0 0 24 24">
              <Styled.ProgressTrack cx={12} cy={12} r={RING_RADIUS} />
              <Styled.ProgressIndicator
                cx={12}
                cy={12}
                r={RING_RADIUS}
                strokeDasharray={RING_CIRCUMFERENCE}
                strokeDashoffset={RING_CIRCUMFERENCE * (1 - progress)}
              />
            </Styled.ProgressRing>
            <Styled.StopSquare />
          </>
        ) : (
          <PlayIcon />
        )}
      </Styled.IconSlot>
      <Text type="h4" color="secondary">
        {translate(T.SPEECH_LABEL)}
      </Text>
    </Styled.PlayControlWrapper>
  )
}

export default memo(PlayControl)
